import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const emailRegex = /^[a-z0-9.!#$%&'*+-/=?^_`{|}~]+@(?:[a-z0-9-]+\.)+[a-z]{2,}$/; // NOSONAR
export const emailValid = (control: FormControl) =>
    emailRegex.test((control.value || "").toLowerCase()) ? null : { EmailInvalid: messages.validation.emailInvalid };

export const emailValidNoRequired = (control: FormControl) =>
    !control?.value || emailRegex.test(control.value.toLowerCase()) ? null : { EmailInvalid: messages.validation.emailInvalid };
